export default __webpack_public_path__ + "static/media/503.3608e18c.png";